import { CoreAction } from 'ia-react-core/~/interfaces/CoreAction';
import { AddressFormState } from 'ia-react-core/~/interfaces/AddressFormState';
import startManualAddressEntryById from '../../../actions/addressForm-fn/startManualAddressEntryById';
import startManualAddressEntryByName from '../../../actions/addressForm-fn/startManualAddressEntryByName';
import stopManualAddressEntryById from '../../../actions/addressForm-fn/stopManualAddressEntryById';
import stopManualAddressEntryByName from '../../../actions/addressForm-fn/stopManualAddressEntryByName';

export default function formReducer(state: AddressFormState, action: CoreAction) {
  const { formId, name } = state;

  switch (action.type) {
    case `${startManualAddressEntryById.type}/${formId}`:
    case `${startManualAddressEntryByName.type}/${name}`:
      return reduceStartManualEntry(state);
    case `${stopManualAddressEntryById.type}/${formId}`:
    case `${stopManualAddressEntryByName.type}/${name}`:
      return reduceStopManualEntry(state);
    default:
      return state;
  }
}

function reduceStartManualEntry(state: AddressFormState) {
  return {
    ...state,
    isManualEntry: true,
  };
}

function reduceStopManualEntry(state: AddressFormState): AddressFormState {
  return {
    ...state,
    isManualEntry: false,
  };
}
